export default "__VITE_ASSET__CWC8rfrn__"